import React from "react";
import styled from "styled-components";
import { getThemeColor, getFontFamily, r } from "../../utils";

// We'll need a second P that is description / body text.
export const P = styled.p`
  font-size: 1.5rem;
  line-height: 1.5;
  color: ${getThemeColor("dark")};
  ${getFontFamily};
  text-align: ${({ align = "left" }) => align};
  ${r("padding-bottom", "0", ".625rem")};
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  padding-bottom: .5rem;
  color: ${getThemeColor("dark")};
  text-align: ${({ align = "left" }) => align};
  ${getFontFamily};
`;



// WEBPACK FOOTER //
// ./src/components/typography/Body.js